// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqQuoteDetailsInformationStyles } from "@conklin/Overrides/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsInformation";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.jobNameHeadingAndText = {
    ...xOrderInformationStyles?.headingAndTextStyles,
};

rfqQuoteDetailsInformationStyles.expirationDateLabelWrapper = {
    ...mergeWithCss(xOrderInformationStyles?.headingAndTextStyles?.wrapper, {
        css: css`
            align-items: flex-start;
        `,
    }),
};

rfqQuoteDetailsInformationStyles.expirationDateLabelText = {
    ...xOrderInformationStyles?.headingAndTextStyles?.heading,
};

rfqQuoteDetailsInformationStyles.customerHeadingAndText = {
    ...xOrderInformationStyles?.headingAndTextStyles,
};

rfqQuoteDetailsInformationStyles.shipToHeadingAndText = {
    ...xOrderInformationStyles?.headingAndTextStyles,
};
